import { Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useGetDoctorAnalyticQuery } from "app/store/dashboard/doctor_analytic/api/doctorAnalyticApi";
import EmptyContainer from "components/common/empty_container/EmptyContainer";
import Loading from "components/common/loading/Loading";

import Doctor from "components/pages/dashboard/doctor_analytic/Doctor";
import DoctorAnalyticModal from "components/pages/dashboard/doctor_analytic/modal/DoctorAnalyticModal";
import { changeFilter } from "app/store/dashboard/doctor_analytic/slice/doctorAnalyticSlice";
import { getEndDate, getFormattedDate, getStartDate } from "utils/date";
import { DATE_FORMAT } from "static/date";
import { showErrorToast } from "utils/toast";
import DateRangeFilter from "components/common/filters/daterange/DateRangeFilter";
import { dateStyle } from "components/common/filters/daterange/daterangeFilterStyle";

const DoctorAnalytic = () => {
  const dispatch = useDispatch();

  const { startDate, endDate, account, sort, name } = useSelector(
    (state) => state.doctorAnalytic
  );

  const { data, isLoading, isFetching, isError, error } =
    useGetDoctorAnalyticQuery(
      {
        startDate,
        endDate,
        account,
        sort,
        name,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    const startDate = getStartDate("year");
    const endDate = getEndDate();

    dispatch(
      changeFilter({
        type: "startDate",
        value: startDate,
      })
    );

    dispatch(
      changeFilter({
        type: "endDate",
        value: endDate,
      })
    );
  }, []);

  useEffect(() => {
    if (isError && error?.message) {
      showErrorToast(error?.message);
    }
  }, [isError]);

  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ marginBottom: "20px" }}
        >
          <Grid item md={6}>
            <Typography
              variant="h6"
              style={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              Doctors - Signed Transmissions
            </Typography>
          </Grid>
          <Grid item>
            <Grid item container columnSpacing={1} alignItems="center">
              <DateRangeFilter
                startDate={startDate}
                endDate={endDate}
                handleStartDate={(date) => {
                  dispatch(
                    changeFilter({
                      type: "startDate",
                      value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
                    })
                  );
                }}
                handleEndDate={(date) => {
                  dispatch(
                    changeFilter({
                      type: "endDate",
                      value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
                    })
                  );
                }}
                style={{
                  ...dateStyle,
                  width: "100%",
                }}
              />
              <Grid item>
                {data && (
                  <DoctorAnalyticModal
                    data={data}
                    isLoading={isLoading || isFetching}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          {isLoading || isFetching ? (
            <Loading height="350px" />
          ) : data?.length > 0 ? (
            data?.slice(0, 3)?.map(({ name, report }, index) => (
              <Grid key={index} container item marginBottom={2}>
                <Doctor name={name} report={report} />
              </Grid>
            ))
          ) : (
            <EmptyContainer height="350px" noDataText="No data available" />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DoctorAnalytic;
